import { createContext, useState } from 'react';
import Script from 'next/script';

export const ChargebeeContext = createContext();

export const ChargebeeContextProvider = ({ children }) => {
  const [instance, setInstance] = useState();

  const handleLoad = () => {
    window.Chargebee.init({
      site: process.env.NEXT_PUBLIC_LEARNING_CHARGEBEE_SITE,
    });
  };

  const handleReady = () => {
    setInstance(window.Chargebee.getInstance());
  };

  return (
    <ChargebeeContext.Provider value={instance}>
      <Script
        onLoad={handleLoad}
        onReady={handleReady}
        src="https://js.chargebee.com/v2/chargebee.js"
      />
      {children}
    </ChargebeeContext.Provider>
  );
};
